import { dispatchPromise, fetchResources } from './action-helpers';

const DEFAULT_TASK_GROUP_PROPS = {
    id: null,
    name: '',
    order: Number.POSITIVE_INFINITY,
    project: null,
    assignees: []
};

export const createTaskGroup = taskGroupProps => {
    return dispatchPromise({
        type: 'TASK_GROUP_CREATE_REQUESTED',
        payload: {
            taskGroup: Object.assign({}, DEFAULT_TASK_GROUP_PROPS, taskGroupProps)
        }
    });
}

export const fetchTaskGroups = (projectId, all) => fetchResources('TASK_GROUPS_FETCH_REQUESTED', { projectId }, all);

export const fetchTaskGroup = taskGroupId => {
    return dispatchPromise({
        type: 'TASK_GROUP_FETCH_REQUESTED',
        payload: { taskGroupId }
    });
}

export const updateTaskGroup = (taskGroupId, taskGroupProps, preventSave) => {
    return dispatchPromise({
        type: 'TASK_GROUP_UPDATE_REQUESTED',
        preventSave,
        payload: {
            taskGroupId,
            taskGroupProps
        }
    });
}

export const removeTaskGroup = taskGroupId => {
    return dispatchPromise({
        type: 'TASK_GROUP_REMOVE_REQUESTED',
        payload: { taskGroupId }
    });
}

export const assignTaskGroup = (taskGroupId, assignees) => {
    return dispatchPromise({
        type: 'TASK_GROUP_ASSIGN_REQUESTED',
        payload: {
            taskGroupId,
            assignees
        }
    });
}

export const unassignTaskGroup = (taskGroupId, assignees) => {
    return dispatchPromise({
        type: 'TASK_GROUP_UNASSIGN_REQUESTED',
        payload: {
            taskGroupId,
            assignees
        }
    });
}

export const moveAllTaskGroupTasks = (sourceTaskGroupId, targetTaskGroupId, targetProjectId) => {
    return dispatchPromise({
        type: 'TASK_GROUP_MOVE_ALL_TASKS_REQUESTED',
        payload: {
            sourceTaskGroupId,
            targetTaskGroupId,
            targetProjectId
        }
    });
}

export const setTaskGroupVisibility = (taskGroupId, visible, roles) => {
    return dispatchPromise({
        type: 'TASK_GROUP_VISIBILITY_SET_REQUESTED',
        payload: {
            taskGroupId,
            visible,
            roles
        }
    });
}

export const tieToMilestone = taskGroupId => {
    return dispatchPromise({
        type: 'TASK_GROUP_TIE_TO_MILESTONE_REQUESTED',
        payload: {
            taskGroupId
        }
    });
}

export const untieFromMilestone = taskGroupId => {
    return dispatchPromise({
        type: 'TASK_GROUP_UNTIE_FROM_MILESTONE_REQUESTED',
        payload: {
            taskGroupId
        }
    });
}

export const reorderTaskGroups = taskGroups => {
    return dispatchPromise({
        type: 'TASK_GROUPS_REORDER_REQUESTED',
        payload: { taskGroups }
    });
}
